import { ProfileInfo } from '../models';
import MenuStructure from './MenuProvider/MenuStructure';
import { computed, inject } from 'vue';
import { UserClaimsKey, UserClaimsProvide } from '../injectionKeys';

export function useSiteNavigation(props: Readonly<{ menuItems?: MenuStructure; currentLanguage?: string; isLoggedIn: boolean }>) {
    const currentLanguage = getCurrentLanguage(props);
    const topMenu = computed(() =>
        (props.menuItems?.topMenu?.[currentLanguage.value] || [])
            .filter(m => (props.isLoggedIn ? m.availableForAuthorized : m.availableForAnonymous))
            .map(x => ({
                ...x,
                childPages: x.childPages?.filter(p => (props.isLoggedIn ? p.availableForAuthorized : p.availableForAnonymous))
            }))
    );
    const userClaims = inject<UserClaimsProvide>(UserClaimsKey);
    const loginLink = computed(() => props.menuItems?.loginLink?.[currentLanguage.value]);
    const logoutLink = computed(() => {
        const link = { ...props.menuItems?.logoutLink?.[currentLanguage.value] };
        if (userClaims) link.link = userClaims.value.find(c => c.type === 'bff:logout_url')?.value as string;
        return link;
    });
    const searchPage = computed(() => props.menuItems?.searchLink?.[currentLanguage.value]);
    const contactUsPage = computed(() => props.menuItems?.contactUsLink?.[currentLanguage.value]);

    return {
        topMenu,
        loginLink,
        logoutLink,
        searchPage,
        contactUsPage
    };
}

export function useProfileNavigation(props: Readonly<{ profileInfo?: ProfileInfo; currentLanguage?: string }>) {
    const profilePageLink = computed(() => props.profileInfo?.profilePage?.[getCurrentLanguage(props).value].link);
    const profilePageInfo = computed(() => props.profileInfo?.profilePage?.[getCurrentLanguage(props).value]);
    const myPageLink = computed(() => props.profileInfo?.myPage?.[getCurrentLanguage(props).value].link);
    const myPageInfo = computed(() => props.profileInfo?.myPage?.[getCurrentLanguage(props).value]);

    return {
        profilePageInfo,
        profilePageLink,
        myPageInfo,
        myPageLink
    };
}

function getCurrentLanguage(props?: { currentLanguage?: string }) {
    return computed(() => props?.currentLanguage ?? 'no');
}
